import { EsVisit } from './elasticsearch.types';
import { createApi as coreCreateApi } from './core';

declare const healConfig: any;

function createApi(hideMessage = false) {
  return coreCreateApi({ baseURL: healConfig.opsApiBaseUrl + '/visit', hideMessage });
}

function searchElastic(body: any): Promise<EsVisit[]> {
  return createApi(true)
    .then((api) => api.post<any>(`/search`, body))
    .then((r) => (r.ok && r.data ? r.data.results : Promise.reject(`Failed to search query`)));
}

function searchTerm(term: string, size = 5000): Promise<EsVisit[]> {
  return createApi()
    .then((api) => api.get<any>(`/search/term?${term}`, { size }))
    .then((r) => (r.ok && r.data ? r.data.results : Promise.reject(`Failed to search term ${term}`)));
}

export function visitSearchByAssistantId(assistantId: string): Promise<EsVisit[]> {
  return searchTerm(`assistant_id=${assistantId}`);
}

export function visitSearchByDoctorId(doctorId: string): Promise<EsVisit[]> {
  return searchTerm(`doctor_id=${doctorId}`);
}

export function visitSearchByPatientId(patientId: string): Promise<EsVisit[]> {
  return searchTerm(`patient_id=${patientId}`);
}

export function visitSearch(query: string): Promise<EsVisit[]> {
  return createApi()
    .then((api) => api.get<any>(`/search?q=${query}`))
    .then((r) => (r.ok && r.data ? r.data.results : Promise.reject(`Failed to search query ${query}`)));
}

export function visitSearchStatus(): Promise<{ most_recent_update: string }> {
  return createApi()
    .then((api) => api.get<any>(`/search/status`))
    .then((r) => (r.ok ? r.data : Promise.reject(`Failed to get status`)));
}

export function searchQuery(query: string, size = 1000): Promise<EsVisit[]> {
  return searchElastic({
    size,
    query: {
      bool: {
        must: [
          {
            query_string: {
              query,
              analyze_wildcard: true,
              time_zone: 'America/Los_Angeles',
            },
          },
        ],
        filter: [],
        should: [],
        must_not: [],
      },
    },
  });
}

export function searchIndex(index: string, query: string, filter: any[] = [], size = 1000): Promise<any> {
  const body = {
    size,
    query: {
      bool: {
        must: [
          {
            query_string: {
              query,
              analyze_wildcard: true,
              time_zone: 'America/Los_Angeles',
            },
          },
        ],
        filter,
        should: [],
        must_not: [],
      },
    },
  };

  return coreCreateApi({ baseURL: `https://healthmetrics.${healConfig.env}-uswest2.heal.com/${index}`, hideMessage: true })
    .then((api) => api.post<any>(`/_search`, body))
    .then((r) => (r.ok && r.data ? r.data : Promise.reject(`Failed to search query`)))
    .then((data) => data.hits.hits.map((h: any) => h._source));
}
